import React from "react"
import {Button} from "@mui/material"

import {RevokeOfferModal} from "./RevokeOfferModal"

type RemoveOfferButtonProps = {
	offerID: string
}

function RemoveOfferButton({offerID}: RemoveOfferButtonProps) {
	const [modalOpen, setModalOpen] = React.useState(false)

	const handleSuccess = () => {
		setModalOpen(false)
	}

	return (
		<>
			<Button
				variant="contained"
				size="small"
				onClick={() => setModalOpen(true)}
				sx={{
					backgroundColor: "#D92D20",
					"&:hover": {backgroundColor: "#b91c1c"},
					textTransform: "uppercase",
					fontWeight: 500,
					letterSpacing: "0.4px",
					borderRadius: "4px",
					whiteSpace: "nowrap",
				}}
			>
				Remove Offer
			</Button>
			{modalOpen && (
				<RevokeOfferModal
					offerID={offerID}
					open={modalOpen}
					onClose={() => setModalOpen(false)}
					onSuccess={handleSuccess}
				/>
			)}
		</>
	)
}

export {RemoveOfferButton}
